import { sha256 } from 'crypto-hash';

const fallbackSha256 = async (input: string) => {
  const sha256 = await import('hash.js').then(
    (module) => module.default.sha256,
  );
  return sha256().update(input).digest('hex');
};

export const getSha256 = () => {
  if (typeof window === 'undefined' || window.isSecureContext) {
    return sha256;
  } else {
    return fallbackSha256;
  }
};
